import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { bindDomainManual } from '../apis';
import { toast } from 'react-toastify';

const useBindDomainManual = () => {
  const mutationData = useMutation({
    mutationFn: bindDomainManual,
    onSuccess: (data) => {
      toast.success('Bind custom domain successfully');
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error Bind custom domain:', error);
    },
  });

  return mutationData;
};

export default useBindDomainManual;
